<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Add a new datum</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-text-field label="Datum" v-model="datum" :rules="datumNameRules"></v-text-field>
                <v-text-field label="Description" v-model="datumDescription"></v-text-field>
                <v-select label="Datum Type" v-model="datumTypeAdd" :items="[datumType.Height, datumType.Depth]">
                </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()">
              <v-icon class="mr-1">done</v-icon>{{ $t('Button.Create') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const datums = createNamespacedHelpers('datum')

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      datumList: {
        type: Array,
      },
      name: {
        type: String,
      },
    },
    data() {
      return {
        dialog: '',
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,
        datum: '',
        datumDescription: '',
        datumTypeAdd: '',
        datumType: {
          Height: 'Height',
          Depth: 'Depth',
        },
        datumNameRules: [
          (v) => !!v || 'Datum name is required',
          (v) => this.datumList.find(x => x.DatumName == v) == null || 'Datum already exists',
        ],
      }
    },
    watch: {
      show() {
        this.dialog = true
      },
    },
    methods: {
      ...datums.mapActions(['postDatum']),
      submit() {
        var self = this
        if (this.$refs.form.validate()) {
          let options = {
            tenantName: this.name,
            data: {
              DatumType: {
                Name: this.datumTypeAdd,
              },
              DatumName: this.datum,
              DatumDescription: this.datumDescription,
            },
            successCb: () => {
              self.$emit('refreshDatumList')
              self.successCb()
            },
          }

          this.postDatum(options)
        } else {
          this.failedCb()
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
      successCb() {
        this.snackMessage = 'Datum ' + this.datum + ' added successfully'
        this.snackColor = 'success'
        this.snackbar = true
        this.clearForm()
      },
      failedCb() {
        this.snackColor = 'error'
        this.snackMessage = 'Error adding datum'
        this.snackbar = true
      },
    },
  }
</script>